import React from "react";
import {
  Img,
  interpolate,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";
import { resolveIconSrc, DEFAULT_ICONS } from "./iconMap";

const SecondStage = ({
  stageTiming,
  stageEnding,
  icons,
  icon1,
  icon2,
  icon3,
}) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const stageDuration = Math.max(1, stageEnding - stageTiming);
  const fadeInDuration = Math.min(30, Math.max(5, stageDuration * 0.15));
  const fadeOutDuration = Math.min(20, Math.max(5, stageDuration * 0.1));

  const containerOpacity = interpolate(
    frame,
    [
      stageTiming,
      stageTiming + fadeInDuration,
      stageEnding - fadeOutDuration,
      stageEnding,
    ],
    [0, 1, 1, 0],
    {
      extrapolateLeft: "clamp",
      extrapolateRight: "clamp",
    },
  );

  const rawList =
    Array.isArray(icons) && icons.length > 0 ? icons : [icon1, icon2, icon3];

  const resolvedIcons = [0, 1, 2].map((idx) => {
    const rawVal = rawList[idx] || DEFAULT_ICONS[idx];
    return {
      id: idx,
      src: resolveIconSrc(rawVal, idx),
    };
  });

  return (
    <div
      style={{
        position: "absolute",
        top: "38%",
        left: "40%",
        zIndex: 25,
        opacity: containerOpacity,
        pointerEvents: "none",
      }}
    >
      <div style={{ display: "flex", gap: "40px", alignItems: "center" }}>
        {resolvedIcons.map((item) => {
          const staggerDelay = item.id * 15;

          const iconProgress = spring({
            fps,
            frame: frame - stageTiming - staggerDelay,
            config: { damping: 12, mass: 1, stiffness: 190 },
          });

          const scale = interpolate(iconProgress, [0, 1], [0, 1], {
            extrapolateLeft: "clamp",
            extrapolateRight: "clamp",
          });

          const opacity = interpolate(iconProgress, [0, 1], [0, 1], {
            extrapolateLeft: "clamp",
            extrapolateRight: "clamp",
          });

          return (
            <div
              key={item.id}
              style={{
                width: 300,
                height: 300,
                margin: 0,
                padding: 0,
                opacity,
                transform: `scale(${scale})`,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Img
                src={item.src}
                alt={`sc-icon-${item.id}`}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SecondStage;
